import { render, staticRenderFns } from "./EudrAreaPlantadaEmCoberturaFlorestal2020.vue?vue&type=template&id=809876f8&lang=pug"
import script from "./EudrAreaPlantadaEmCoberturaFlorestal2020.vue?vue&type=script&lang=js"
export * from "./EudrAreaPlantadaEmCoberturaFlorestal2020.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports